(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-context/assets/javascripts/use-competition-id.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-context/assets/javascripts/use-competition-id.js');
"use strict";

const {
  CompetitionContext
} = svs.components.marketplaceCompetition.competitionContext;
const {
  useContext
} = React;
const logger = svs.core.log.getLogger('marketplace-competition:use-competition-id');
const useCompetitionId = () => {
  const context = useContext(CompetitionContext);
  if (context === undefined) {
    logger.info("Mkp-competition: context undefined, use-competition-id.es6");
    throw new Error('useCompetitionId must be used within a CompetitionProvider');
  }
  return context.competitionId;
};
setGlobal('svs.components.marketplaceCompetition.competitionContext.useCompetitionId', useCompetitionId);

 })(window);